module.exports = __webpack_public_path__ + "img/4.28438460.png";